import { jsx as _jsx } from "react/jsx-runtime";
import MyLightbox from 'yet-another-react-lightbox';
// eslint-disable-next-line import/no-unresolved
import 'yet-another-react-lightbox/styles.css';
import './LightBox.scss';
export const LightBox = ({ open, onClose, url }) => {
    return (_jsx(MyLightbox, { open: open, close: onClose, slides: [{ src: url }], controller: { closeOnBackdropClick: true } }));
};
